import { apiClient } from '@/lib/api-client';

export interface FriendProfileDoc {
  userId: string;
  name: string;
  gender?: string;
  age?: number;
  city?: string;
  state?: string;
  interests?: string[];
  languages?: string[];
  lookingFor?: string;
  bio?: string;
  premium?: boolean;
  isVerified?: boolean;
  verified?: boolean;
  createdAt?: string;
  avatarUrl?: string;
}

export interface FriendFacetedResult {
  profiles: FriendProfileDoc[];
  totalHits: number;
  page: number;
  size: number;
  facets?: Record<string, Array<{ key: string; count: number }>>;
}

export const friendsApi = {
  getJustJoined(page = 0, size = 12, params: Record<string, any> = {}) {
    const qs = new URLSearchParams();
    qs.set('page', String(page));
    qs.set('size', String(size));
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') qs.set(k, String(v));
    });
    return apiClient.get<FriendFacetedResult>(`/api/search/friends/just-joined?${qs.toString()}`);
  },

  getNearby(lat: number, lon: number, radiusKm = 50, page = 0, size = 12, params: Record<string, any> = {}) {
    const qs = new URLSearchParams();
    qs.set('lat', String(lat));
    qs.set('lon', String(lon));
    qs.set('radiusKm', String(radiusKm));
    qs.set('page', String(page));
    qs.set('size', String(size));
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') qs.set(k, String(v));
    });
    return apiClient.get<FriendFacetedResult>(`/api/search/friends/nearby?${qs.toString()}`);
  },

  search(params: Record<string, any>) {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') qs.set(k, String(v));
    });
    return apiClient.get<FriendFacetedResult>(`/api/search/friends/search?${qs.toString()}`);
  },
};
